import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { showErrorMessage } from '../notifications';
import { ThunkAPI } from '../rootReducer';
import { Environment } from './copyTemplate.slice';

export interface ICopyTemplateRequest {
  templateId: string;
}

export interface ICopyTemplateResponse {
  projectId: string;
  env: Environment;
}

export const copyTemplate: AsyncThunk<ICopyTemplateResponse, ICopyTemplateRequest, ThunkAPI> = createAsyncThunk(
  'template/copy',
  async (data: ICopyTemplateRequest, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<ICopyTemplateResponse, ICopyTemplateRequest>({
        endpoint: `template/copy/${data.templateId}`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(data, thunk);

      return response;
    } catch (error) {
      thunk.dispatch(showErrorMessage('There was an error while preparing your project, please try again later'));
      return thunk.rejectWithValue(error);
    }
  }
);